import { render, staticRenderFns } from "./ExplainDialog.vue?vue&type=template&id=710f95cb&scoped=true&"
import script from "./ExplainDialog.vue?vue&type=script&lang=js&"
export * from "./ExplainDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExplainDialog.vue?vue&type=style&index=0&id=710f95cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f95cb",
  null
  
)

export default component.exports